import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDatacampComponent } from './simple-icons-datacamp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDatacampComponent ],
    exports:      [ SimpleIconsDatacampComponent ],
    bootstrap:    []
})
export class SimpleIconsDatacampModule {}
